import React, { useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { clearFormValues, RestfullApiService } from "../../config/service";

import { dateFormat, removeSpace } from "../../utils";
import { MEDIA_URL } from "../../config/url";
import { encryptData } from "../../utils/storage";
import toast from "react-hot-toast";
import { useSelector } from "react-redux";
import DivLoader from "../../utils/DivLoader";
import noResultFound from "../../assets/img/general/not-found.png";

const EventList = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const user = useSelector((state) => state.user.userProfile);
  const isLoggedIn = useSelector((state) => state.user.isLoggedIn);

  const [showMobileFilter, setShowMobileFilter] = useState(false);
  const [search, setSearch] = useState("");
  const [eventTable, setEventTable] = useState([]);
  const [sportTable, setSportTable] = useState([]);
  const [selectedSports, setSelectedSports] = useState([]);
  const [cityTable, setCityTable] = useState([]);
  const [selectedCities, setSelectedCities] = useState([]);
  const [monthTable, setMonthTable] = useState([]);
  const [selectedMonths, setSelectedMonths] = useState([]);
  const [eventTableList, setEventTableList] = useState([]);
  const [loadingEvents, setLoadingEvents] = useState(false);

  const getSelectedValuesString = (selectedArray) => {
    return selectedArray.join(",");
  };

  const updateAndFetchEvents = async (
    updatedSports,
    updatedCities,
    updatedMonths
  ) => {
    const Sport = getSelectedValuesString(updatedSports);
    const City = getSelectedValuesString(updatedCities);
    const Month = getSelectedValuesString(updatedMonths);
    const data = { search, Sport, City, Month };
    const response = await loadEventList(data);
    console.log(response);
    setEventTable(response?.data?.Result?.Table1);
  };

  const handleCheckboxChange = (
    value,
    setSelectedState,
    selectedState,
    setTableState,
    isMobile = false
  ) => {
    const updatedSelections = selectedState.includes(value)
      ? selectedState.filter((val) => val !== value)
      : [...selectedState, value];

    setSelectedState(updatedSelections);
    setTableState((prevState) => {
      return prevState?.map((item) => {
        if (item.value === value) {
          return { ...item, isSelected: !item.isSelected };
        }
        return item;
      });
    });

    // Update and fetch events with the new selections
    updateAndFetchEvents(
      setSelectedState === setSelectedSports
        ? updatedSelections
        : selectedSports,
      setSelectedState === setSelectedCities
        ? updatedSelections
        : selectedCities,
      setSelectedState === setSelectedMonths
        ? updatedSelections
        : selectedMonths
    );

    if (isMobile) {
      // setShowMobileFilter(false);
    }
  };
  const navigateChange = (
    value,
    setSelectedState,
    selectedState,
    setTableState
  ) => {
    console.log(value, setSelectedState, selectedState);

    const updatedSelections = selectedState.includes(value)
      ? selectedState.filter((val) => val !== value)
      : [...selectedState, value];

    setSelectedState(updatedSelections);

    // Update and fetch events with the new selections
    updateAndFetchEvents(
      setSelectedState === setSelectedSports
        ? updatedSelections
        : selectedSports,
      setSelectedState === setSelectedCities
        ? updatedSelections
        : selectedCities,
      setSelectedState === setSelectedMonths
        ? updatedSelections
        : selectedMonths
    );
  };
  const shareContent = async (eventId, displayName) => {
    const encryptedParam = encryptData(eventId);
    const url1 = window.location.host;
    const url = `${url1}/event-details/${removeSpace(
      displayName
    )}/${encryptedParam}`;
    const message = `Check out this event: ${url}`;
    if (navigator.share) {
      try {
        await navigator.share({
          title: "Check out this awesome content!",
          text: message, // Full message including the URL
          // Omitting url property
        });
        console.log("Content shared successfully");
      } catch (error) {
        console.error("Error sharing content:", error);
      }
    } else {
      console.log("Share API not supported");
      // Optionally provide a fallback here
    }
  };

  // const shareContent = async () => {
  //   const url = window.location.href;
  //   const message = `Check out this event:\n${url}`;
  //   if (navigator.share) {
  //     try {
  //       await navigator.share({
  //         title: "Check out this awesome content!",
  //         text: message, // Include the full message here
  //         url: url, // Provide the URL separately
  //       });
  //       console.log("Content shared successfully");
  //     } catch (error) {
  //       console.error("Error sharing content:", error);
  //     }
  //   } else {
  //     console.log("Share API not supported");
  //     // Optionally provide a fallback here
  //   }
  // };

  // const user = JSON.parse(localStorage.getItem("userProf"));

  async function loadEventList(data) {
    console.log(data.search);
    const reqdata = {
      Method_Name: "filter",
      Month: data.Month || "",
      Sport_Id: data.Sport || "",
      City_Id: data.City || "",
      Event_Id: "",
      Session_User_Id: user?.Participant_Id,
      SearchBy: data.search,
    };
    try {
      setLoadingEvents(true);
      const result = await RestfullApiService(
        reqdata,
        "participant/event_list"
      );
      if (result) {
        return result;
      }
    } catch (err) {
      console.log(err);
    } finally {
      setLoadingEvents(false);
    }
  }

  const addToWishlist = async (EventId, EventName, index) => {
    if (!user) {
      console.error("User data not found");
      return;
    }

    const reqdata = {
      Org_Id: user?.Org_Id,
      Session_User_Id: user?.Participant_Id,
      Session_User_Name: `${user?.First_Name} ${user?.Last_Name}`,
      Method_Name: "AddTowish",
      Event_Id: EventId,
      Display_Name: EventName,
    };

    try {
      const result = await RestfullApiService(
        reqdata,
        "participant/wishlist_set"
      );

      if (result) {
        console.log("Add operation successful:", result);
        toast.success("Added to Wishlist!");

        setEventTableList((prevList) => {
          const updatedList = [...prevList];
          updatedList[index].Isin_wishlist = EventId;
          return updatedList;
        });
      }
    } catch (err) {
      console.error("API Error:", err);
      toast.error("Failed to add to wishlist");
    }
  };

  const deleteFromWishlist = async (EventId, EventName, index) => {
    if (!user) {
      console.error("User data not found");
      return;
    }

    const reqdata = {
      Org_Id: user?.Org_Id,
      Session_User_Id: user?.Participant_Id,
      Session_User_Name: `${user?.First_Name} ${user?.Last_Name}`,
      Method_Name: "Delete",
      Event_Id: EventId,
      Display_Name: EventName,
    };

    try {
      const result = await RestfullApiService(
        reqdata,
        "participant/wishlist_set"
      );

      if (result) {
        console.log("Delete operation successful:", result);
        toast.error("Removed from Wishlist!");

        setEventTableList((prevList) => {
          const updatedList = [...prevList];
          updatedList[index].Isin_wishlist = "false";
          return updatedList;
        });
      }
    } catch (err) {
      console.error("API Error:", err);
      toast.error("Failed to remove from wishlist");
    }
  };

  const handleLoginCheck = (index, eventId, eventName, isInWishlist) => {
    // const isLoggedIn = localStorage.getItem("userProf");
    if (!isLoggedIn) {
      navigate("/login");
    } else {
      if (isInWishlist === "false") {
        addToWishlist(eventId, eventName, index);
      } else {
        deleteFromWishlist(eventId, eventName, index);
      }
    }
  };

  useEffect(() => {
    clearFormValues();
    async function fetchEvents() {
      const sportCategory = localStorage.getItem("navigateSelectedCategory");
      const clickedCity = localStorage.getItem("navigateSelectedCity");
      const searchEvent = location.state || {};
      setSearch(searchEvent.search);
      const response = await loadEventList(searchEvent);

      console.log(location.state);
      console.log(response);
      if (response) {
        setEventTable(response?.data?.Result?.Table1);

        const selectedSportsArray = response?.data?.Result?.Table3?.map(
          (dec) => {
            return { ...dec, isSelected: false };
          }
        );
        if (sportCategory) {
          const selectedCategory = selectedSportsArray?.map((sp) => {
            if (sp?.label === sportCategory) {
              return { ...sp, isSelected: true };
            }
            return sp;
          });
          // console.log(selectedCategory);
          setSportTable(selectedCategory);
          const oneCategory = selectedSportsArray?.filter(
            (sp) => sp?.label === sportCategory
          );
          console.log(oneCategory);
          navigateChange(
            oneCategory[0]?.value,
            setSelectedSports,
            selectedSports,
            setSportTable
          );
        } else {
          setSportTable(selectedSportsArray);
        }

        const selectedCitiesArray = response?.data?.Result?.Table2?.map(
          (dec) => {
            return { ...dec, isSelected: false };
          }
        );
        if (clickedCity) {
          const clickedCities = selectedCitiesArray?.map((cit) => {
            if (cit?.label === clickedCity) {
              return { ...cit, isSelected: true };
            }
            return cit;
          });

          setCityTable(clickedCities);

          const oneCity = selectedCitiesArray?.filter(
            (cit) => cit?.label === clickedCity
          );
          console.log(oneCity);
          navigateChange(
            oneCity[0]?.value,
            setSelectedCities,
            selectedCities,
            setCityTable
          );
        } else {
          setCityTable(selectedCitiesArray);
        }

        const selectedMonths = response?.data?.Result?.Table4?.map((dec) => {
          return { ...dec, isSelected: false };
        });
        setMonthTable(selectedMonths);
      }
    }
    fetchEvents();
  }, [location.state]);
  useEffect(() => {
    const arr = Object.values(eventTable);
    setEventTableList(arr);
  }, [eventTable]);

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });

    return () => {
      localStorage.removeItem("navigateSelectedCategory");
      localStorage.removeItem("navigateSelectedCity");
    };
  }, []);

  return (
    <>
      {/* <section className="layout-pt-lg layout-pb-lg bg-light-2">
        <div className="container">
          <div className="row">
            <div className="col-12">
              <div className="text-center">
                <h1 className="text-30 fw-600 text-primary">Upcoming Events</h1>
              </div>
            </div>
          </div>
        </div>
      </section> */}

      {/* Filters */}
      <section
        style={{ marginTop: "80px" }}
        className="py-5 d-flex items-center bg-blue-1-05"
      >
        <div className="container">
          <div className="row y-gap-10 font-inter items-center justify-between">
            <div className="col-auto">
              <div className="row x-gap-10 y-gap-5 items-center text-14 fw-500 text-light-1">
                <div className="col-auto">
                  <a href="/" className="cursor-pointer">
                    Home
                  </a>
                </div>

                <div
                  className="col-auto p-0"
                  style={{ paddingLeft: "0px !important" }}
                >
                  {/* <div className=""> */}
                  {">"}
                  {/* </div> */}
                </div>
                <div className="col-auto">
                  <div className="text-primary ">Events</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="layout-pt-md layout-pb-lg">
        <div className="container">
          <div className="row y-gap-30">
            <div className="col-xl-3 col-lg-4 lg:d-none">
              <aside className="sidebar y-gap-40">
                <div className="sidebar__item -no-border">
                  <h5 className="text-24 fw-600 mb-10">Sports Type</h5>
                  <div className="sidebar-checkbox">
                    {sportTable?.map((item, index) => {
                      return (
                        <div
                          id={index}
                          className="row y-gap-10 items-center justify-between"
                        >
                          <div className="col-auto">
                            <div className="d-flex items-center">
                              <div className="form-checkbox">
                                <input
                                  type="checkbox"
                                  checked={item.isSelected}
                                  onChange={() => {
                                    // handleSportsSelected(item.value);
                                    handleCheckboxChange(
                                      item.value,
                                      setSelectedSports,
                                      selectedSports,
                                      setSportTable
                                    );
                                  }}
                                />
                                <div className="form-checkbox__mark">
                                  <div className="form-checkbox__icon fas fa-check"></div>
                                </div>
                              </div>
                              <div className="text-15 ml-10">{item.label}</div>
                            </div>
                          </div>
                        </div>
                      );
                    })}
                  </div>
                </div>

                <div className="sidebar__item">
                  <h5 className="text-24 fw-600 mb-10">Location</h5>
                  <div className="sidebar-checkbox">
                    {cityTable?.map((item, index) => {
                      return (
                        <div
                          id={index}
                          className="row y-gap-10 items-center justify-between"
                        >
                          <div className="col-auto">
                            <div className="d-flex items-center">
                              <div className="form-checkbox ">
                                <input
                                  type="checkbox"
                                  checked={item.isSelected}
                                  onChange={() => {
                                    // handleCitiesSelected(item.value);
                                    handleCheckboxChange(
                                      item.value,
                                      setSelectedCities,
                                      selectedCities,
                                      setCityTable
                                    );
                                  }}
                                />
                                <div className="form-checkbox__mark">
                                  <div className="form-checkbox__icon fas fa-check"></div>
                                </div>
                              </div>
                              <div className="text-15 ml-10">{item.label}</div>
                            </div>
                          </div>
                        </div>
                      );
                    })}
                  </div>
                </div>

                <div className="sidebar__item">
                  <h5 className="text-24 fw-600 mb-10">Months</h5>
                  <div className="sidebar-checkbox">
                    {monthTable?.map((item, index) => {
                      return (
                        <div
                          id={index}
                          className="row y-gap-10 items-center justify-between"
                        >
                          <div className="col-auto">
                            <div className="d-flex items-center">
                              <div className="form-checkbox ">
                                <input
                                  type="checkbox"
                                  checked={item.isSelected}
                                  onChange={() => {
                                    // handleMonthsSelected(item.value);
                                    handleCheckboxChange(
                                      item.value,
                                      setSelectedMonths,
                                      selectedMonths,
                                      setMonthTable
                                    );
                                  }}
                                />
                                <div className="form-checkbox__mark">
                                  <div className="form-checkbox__icon fas fa-check"></div>
                                </div>
                              </div>
                              <div className="text-15 ml-10">{item.label}</div>
                            </div>
                          </div>
                        </div>
                      );
                    })}
                  </div>
                </div>
              </aside>
            </div>

            <div className="col-xl-9 col-lg-8">
              {/* Event Count */}
              <div className="row y-gap-10 items-center justify-between">
                <div className="col-auto">
                  <div className="text-18">
                    <span className="fw-500">
                      {/* <span className="text-primary">{eventTable?.length}</span>{" "} */}
                      Events
                    </span>{" "}
                    {/* in Mumbai */}
                  </div>
                </div>

                <div className="col-auto">
                  <div className="row x-gap-20 y-gap-20">
                    <div className="col-auto d-none lg:d-block">
                      <button
                        // data-x-click="filterPopup"
                        onClick={() => {
                          setShowMobileFilter(true);
                        }}
                        className="button -grey-1 py-10 px-20 rounded-100 bg-primary text-15 text-white"
                      >
                        <i className="fas fa-filter text-14 mr-10"></i>
                        Filter
                      </button>
                    </div>
                  </div>
                </div>
              </div>

              <div
                className={`filterPopup bg-white${
                  showMobileFilter ? " -is-active" : ""
                }`}
                data-x="filterPopup"
                data-x-toggle="-is-active"
              >
                <aside className="sidebar -mobile-filter">
                  {/* <div
                    className="-icon-close"
                    onClick={() => {
                      setShowMobileFilter(false);
                    }}
                  >
                    <i className="fas fa-times"></i>
                  </div> */}

                  {/* <div className="sidebar__item">
                    <div
                      className="flex-center ratio ratio-15:9 js-lazy"
                      data-bg="/img/general/map.png"
                    >
                      <button
                        className="button py-15 px-24 -blue-1 bg-white text-dark-1 absolute"
                        data-x-click="mapFilter"
                      >
                        <i className="icon-destination text-22 mr-10"></i>
                        Show on map
                      </button>
                    </div>
                  </div> */}

                  <div className="sidebar__item -no-border">
                    <h5 className="text-18 fw-600 mb-10">Sports Type</h5>
                    <div className="sidebar-checkbox">
                      {sportTable?.map((item, index) => {
                        return (
                          <div
                            id={index}
                            className="row y-gap-10 items-center justify-between"
                          >
                            <div className="col-auto">
                              <div className="d-flex items-center">
                                <div className="form-checkbox">
                                  <input
                                    type="checkbox"
                                    checked={item.isSelected}
                                    onChange={() => {
                                      // handleSportsSelected(item.value);
                                      handleCheckboxChange(
                                        item.value,
                                        setSelectedSports,
                                        selectedSports,
                                        setSportTable,
                                        true
                                      );
                                    }}
                                  />
                                  <div className="form-checkbox__mark">
                                    <div className="form-checkbox__icon fas fa-check"></div>
                                  </div>
                                </div>
                                <div className="text-15 ml-10">
                                  {item.label}
                                </div>
                              </div>
                            </div>
                          </div>
                        );
                      })}
                    </div>
                  </div>

                  <div className="sidebar__item">
                    <h5 className="text-18 fw-600 mb-10">Location</h5>
                    <div className="sidebar-checkbox">
                      {cityTable?.map((item, index) => {
                        return (
                          <div
                            id={index}
                            className="row y-gap-10 items-center justify-between"
                          >
                            <div className="col-auto">
                              <div className="d-flex items-center">
                                <div className="form-checkbox ">
                                  <input
                                    type="checkbox"
                                    checked={item.isSelected}
                                    onChange={() => {
                                      // handleCitiesSelected(item.value);
                                      handleCheckboxChange(
                                        item.value,
                                        setSelectedCities,
                                        selectedCities,
                                        setCityTable,
                                        true
                                      );
                                    }}
                                  />
                                  <div className="form-checkbox__mark">
                                    <div className="form-checkbox__icon fas fa-check"></div>
                                  </div>
                                </div>
                                <div className="text-15 ml-10">
                                  {item.label}
                                </div>
                              </div>
                            </div>
                          </div>
                        );
                      })}
                    </div>
                  </div>

                  <div className="sidebar__item">
                    <h5 className="text-18 fw-600 mb-10">Months</h5>
                    <div className="sidebar-checkbox">
                      {monthTable?.map((item, index) => {
                        return (
                          <div
                            id={index}
                            className="row y-gap-10 items-center justify-between"
                          >
                            <div className="col-auto">
                              <div className="d-flex items-center">
                                <div className="form-checkbox ">
                                  <input
                                    type="checkbox"
                                    checked={item.isSelected}
                                    onChange={() => {
                                      // handleMonthsSelected(item.value);
                                      handleCheckboxChange(
                                        item.value,
                                        setSelectedMonths,
                                        selectedMonths,
                                        setMonthTable,
                                        true
                                      );
                                    }}
                                  />
                                  <div className="form-checkbox__mark">
                                    <div className="form-checkbox__icon fas fa-check"></div>
                                  </div>
                                </div>
                                <div className="text-15 ml-10">
                                  {item.label}
                                </div>
                              </div>
                            </div>
                          </div>
                        );
                      })}
                    </div>
                  </div>

                  <button
                    // data-x-click="filterPopup"
                    onClick={() => {
                      setShowMobileFilter(false);
                    }}
                    className="button -grey-1 h-40 px-20 rounded-8 bg-primary text-15 text-white"
                  >
                    <i className="fas fa-filter text-14 mr-10"></i>
                    Apply
                  </button>
                </aside>
              </div>

              {/* Event Card */}
              {loadingEvents && (
                <div className="mt-50 h-20vh relative">
                  <DivLoader />
                </div>
              )}
              {!loadingEvents && (
                <>
                  <div className="mt-30"></div>
                  <div className={`row y-gap-30 d-flex justify-center`}>
                    {eventTable?.length > 0 ? (
                      eventTable?.map((eventDetail, index) => {
                        const encryptedParam = encryptData(
                          eventDetail?.Event_Id
                        );
                        var arraytypevent =
                          eventDetail.Event_Category_List?.split(",");

                        return (
                          <div className="col-12">
                            <Link
                              style={{
                                color: "#000",
                              }}
                            >
                              <div className="border-light py-20 px-20 rounded-16 -hover-shadow">
                                <div className="row x-gap-20 y-gap-20">
                                  <div className="col-md-auto">
                                    <div className="cardImage ratio ratio-5:4 w-250 md:w-1/1 rounded-16">
                                      <Link
                                        to={`/event-details/${removeSpace(
                                          eventDetail.Display_Name
                                        )}/${encryptedParam}`}
                                      >
                                        <div className="cardImage__content">
                                          <img
                                            className="rounded-16 col-12"
                                            src={`${MEDIA_URL}${eventDetail.Image_Path}`}
                                            alt="img-example"
                                          />
                                        </div>
                                      </Link>
                                    </div>
                                  </div>
                                  <div className="col-md">
                                    <div className="col-auto d-flex justify-between">
                                      <h3 className="text-18 font-inter lh-14 fw-600">
                                        <Link
                                          to={`/event-details/${removeSpace(
                                            eventDetail.Display_Name
                                          )}/${encryptedParam}`}
                                        >
                                          {eventDetail.Display_Name}
                                        </Link>
                                      </h3>
                                      <div className="d-flex">
                                        <div className="col-auto">
                                          <button className="button text-white size-30 text-primary text-20">
                                            <i
                                              onClick={() => {
                                                handleLoginCheck(
                                                  index,
                                                  eventDetail.Event_Id,
                                                  eventDetail.Display_Name,
                                                  eventDetail.Isin_wishlist
                                                );
                                              }}
                                              className={`${
                                                eventDetail.Isin_wishlist !==
                                                "false"
                                                  ? "fas fa-heart"
                                                  : " far fa-heart"
                                              }`}
                                            ></i>
                                          </button>
                                        </div>
                                        <div className="col-auto">
                                          <button
                                            onClick={() =>
                                              shareContent(
                                                eventDetail?.Event_Id,
                                                eventDetail.Display_Name
                                              )
                                            }
                                            className="button text-white size-30 text-primary text-20"
                                          >
                                            <i className="fas fa-share"></i>
                                          </button>
                                        </div>
                                      </div>
                                    </div>
                                    <div className="fw-500 text-14">
                                      {eventDetail.Rating === null ||
                                      eventDetail?.Rating === 0 ? (
                                        ""
                                      ) : (
                                        <>
                                          <div className="d-inline-block font-inter mr-10 py-7">
                                            <i className="fas fa-star text-13 text-green"></i>
                                          </div>
                                          {eventDetail?.Rating}
                                        </>
                                      )}
                                    </div>
                                    <div className="row x-gap-10 py-5 y-gap-10 items-center pt-5">
                                      <div className="col-auto fw-500 d-flex items-center x-gap-10">
                                        <i class="fas ml-2 fa-map-marker-alt text-primary"></i>
                                        <span className="text-14 text-reading font-inter fw-600">
                                          {eventDetail?.City_Name},{" "}
                                          {eventDetail?.State}
                                        </span>
                                      </div>
                                      {/* <div className="row x-gap-10 y-gap-10 items-center"> */}
                                      <div className="col-auto fw-500 d-flex py-7 px-5 pl-15 items-center x-gap-10">
                                        <i className="far fa-calendar text-primary"></i>
                                        <span className="text-14 text-reading font-inter fw-600">
                                          {eventDetail?.Start_Date}
                                        </span>
                                      </div>
                                      {/* </div> */}
                                    </div>

                                    <div className="row x-gap-10 y-gap-10 pt-5">
                                      {/* <div className="col-auto">
                                  <div className="bg-light-2 rounded-100 py-5 px-20 text-12 lh-14">
                                    Running
                                  </div>
                                </div> */}
                                      {/* <div className="col-auto">
                                  <div className="bg-light-2 rounded-100 py-5 px-20 text-12 lh-14">
                                    Marathon
                                  </div>
                                </div> */}
                                      {/* <div className="d-flex items-center flex-wrap mt-10 font-inter uppercase"> */}
                                      {arraytypevent
                                        ?.slice(0, 2)
                                        .map((datatype, index) => (
                                          <div
                                            key={`ML${index}`}
                                            className="col-auto"
                                          >
                                            <div className="bg-light-2 rounded-100 font-inter py-5 px-20 fw-600 text-12 lh-14">
                                              {datatype.toUpperCase()}
                                            </div>
                                          </div>
                                        ))}
                                      {arraytypevent?.length > 2 && (
                                        <div className="col-auto mt-1 text-10 fw-500 text-light underline">
                                          <Link
                                            to={`/event-details/${removeSpace(
                                              eventDetail.Display_Name
                                            )}/${encryptedParam}`}
                                          >
                                            +{arraytypevent.length - 2} more..
                                          </Link>
                                        </div>
                                      )}

                                      <p
                                        style={{
                                          color: "#303030",
                                        }}
                                        className="text-14 lg:text-13 py-10 font-inter fw-500"
                                      >
                                        Registrations{" "}
                                        {eventDetail?.Is_Registration_Closed ===
                                        "Closed"
                                          ? "Closed"
                                          : "Closing"}{" "}
                                        on{" "}
                                        <span className="text-primary font-inter fw-600">
                                          {eventDetail.Registration_Date}
                                        </span>
                                      </p>

                                      <div className="container-fluid font-inter d-flex justify-between">
                                        {eventDetail?.Amount !== "Free" ? (
                                          <div className="text-18 lh-12 font-inter fw-600 text-primary">
                                            ₹ {eventDetail?.Amount} Onwards
                                          </div>
                                        ) : (
                                          <div className="text-18 lh-12 font-inter fw-600 text-primary">
                                            {eventDetail?.Amount}
                                          </div>
                                        )}

                                        <div>
                                          {eventDetail.Is_Registration_Closed ===
                                          "Open" ? (
                                            <Link
                                              to={`/event-details/${removeSpace(
                                                eventDetail.Display_Name
                                              )}/${encryptedParam}`}
                                              className="button -md -primary-1 font-inter text-primary justify-end border-primary rounded-25"
                                            >
                                              Register Now
                                            </Link>
                                          ) : (
                                            <Link
                                              to={`/event-details/${removeSpace(
                                                eventDetail.Display_Name
                                              )}/${encryptedParam}`}
                                              disabled
                                              className="button -md -primary-1 text-primary border-primary rounded-25"
                                            >
                                              {/* <p className="fw-500 rounded-25"> */}
                                              Entry Closed
                                              {/* </p> */}
                                            </Link>
                                          )}
                                        </div>
                                      </div>

                                      {/* </div> */}
                                      {/* {eventDetail?.Event_Category_List?.split(
                                  ","
                                )?.map((el) => {
                                  return (
                                    <div className="col-auto">
                                      <div className="bg-light-2 rounded-100 py-5 px-20 text-12 lh-14">
                                        {el}
                                      </div>
                                    </div>
                                  );
                                })} */}
                                    </div>
                                  </div>
                                  {/* <div className="col-md-auto text-right md:text-left relative"> */}
                                  {/* <div className="row x-gap-10 y-gap-10 justify-end items-center md:justify-start"> */}
                                  {/* <div className="col-auto">
                                  <button className="button text-white size-30 text-primary text-20">
                                    

                                    <i
                                      onClick={() => {
                                        handleLoginCheck(
                                          index,
                                          eventDetail.Event_Id,
                                          eventDetail.Display_Name,
                                          eventDetail.Isin_wishlist
                                        );
                                      }}
                                      className={`${
                                        eventDetail.Isin_wishlist !== "false"
                                          ? "fas fa-heart"
                                          : " far fa-heart"
                                      }`}
                                    ></i>
                                  </button>
                                </div>
                                <div className="col-auto">
                                  <button
                                    onClick={() =>
                                      shareContent(eventDetail?.Event_Id)
                                    }
                                    className="button text-white size-30 text-primary text-20"
                                  >
                                    <i className="fas fa-share"></i>
                                  </button>
                                </div> */}
                                  {/* </div> */}

                                  {/* <div className="mt-130"> */}
                                  {/* <div>
                                  {eventDetail.Is_Registration_Closed ===
                                  "Open" ? (
                                    <Link
                                      to={`/event-details/${encryptedParam}`}
                                      className="button -md -primary-1 text-primary border-primary mt-24 rounded-25"
                                    >
                                      Register Now
                                    </Link>
                                  ) : (
                                    <Link
                                      to="#"
                                      className="button -md -primary-1 text-primary border-primary mt-24 rounded-25"
                                    >
                                      Entry Closed
                                    </Link>
                                  )}
                                </div> */}
                                  {/* </div> */}
                                  {/* </div> */}
                                </div>
                              </div>
                            </Link>
                          </div>
                        );
                      })
                    ) : (
                      <img
                        className="col-12"
                        src={noResultFound}
                        alt="not-found"
                        style={{ height: "400px", width: "auto" }}
                      />
                    )}
                  </div>
                </>
              )}
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default EventList;

// const handleSportsSelected = async (value) => {
//   const Sport = getSelectedValuesString([...selectedSports, value]);
//   const City = getSelectedValuesString(selectedCities);
//   const Month = getSelectedValuesString(selectedMonths);
//   const data = { search, Sport, City, Month };
//   const response = await loadEventList(data);
//   setEventTable(response?.Result?.Table1);

//   setSelectedSports([...selectedSports, value]);
//   setSportTable((prevSportsSelected) => {
//     // Create a new array with modified objects
//     return prevSportsSelected.map((item, index) => {
//       if (item.value === value) {
//         // If the index matches the value, toggle the isSelected property
//         return { ...item, isSelected: !item.isSelected };
//       }
//       // For other indexes, return the original item
//       return item;
//     });
//   });
// };

// const handleCitiesSelected = async (value) => {
//   const City = getSelectedValuesString([...selectedCities, value]);
//   const Sport = getSelectedValuesString(selectedSports);
//   const Month = getSelectedValuesString(selectedMonths);
//   const data = { search, Sport, City, Month };
//   const response = await loadEventList(data);
//   setEventTable(response?.Result?.Table1);

//   setSelectedCities([...selectedCities, value]);
//   setCityTable((prevCitiesSelected) => {
//     return prevCitiesSelected.map((item, index) => {
//       if (item.value === value) {
//         return { ...item, isSelected: !item.isSelected };
//       }
//       return item;
//     });
//   });
// };
